import axios from 'axios';

export const GET_AGENTS_INCOMES_URL = '/invoices/getAgentsIncome';
export const GET_AGENTS_INCOMES_EXCEL_URL = '/invoices/getAgentsIncomeForExcel';

export function findAgentsIncomes(queryParams, cancellationHandlers) {
  return axios.get(GET_AGENTS_INCOMES_URL, {params: queryParams, ...cancellationHandlers});
}

export function getAgentsIncomesFile(queryParams) {
  return axios.get(GET_AGENTS_INCOMES_EXCEL_URL, {params: queryParams});
}


